// Module
var code = "<div class=\"modal-header\"> <h3 class=\"modal-title\">Warning!</h3> </div> <div class=\"modal-body\"> About to delete... </div> <div class=\"modal-footer\"> <button class=\"btn btn-warning\" ng-click=\"$dismiss()\">Cancel</button> <button class=\"btn btn-danger\" ng-click=\"$close()\">PROCEED</button> </div>";
// Exports
module.exports = code;